const locale = {
	AGENTS: '',
	SEARCH: '',
	ADDNEWAGENT: '',
	NEW: '',
};

export default locale;
